export default {
    hostname: "https://tmusic.sanplex.tech",
}